import React from 'react';
import { Drawer, List, ListItem, ListItemButton, ListItemText, ListItemIcon, Chip, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import LockIcon from '@mui/icons-material/Lock';

const statusIcons = {
  completed: <CheckCircleIcon color="success" />,
  in_progress: <HourglassEmptyIcon color="warning" />,
  not_started: <RadioButtonUncheckedIcon color="disabled" />,
  locked: <LockIcon color="disabled" />,
};

const statusLabels = {
  completed: 'Completed',
  in_progress: 'In Progress',
  not_started: 'Not Started',
  locked: 'Locked',
};

const StepSidebar = ({ currentStep, steps, stepStatuses, onStepChange, open, onClose }) => {
  
  // Debug logging
  React.useEffect(() => {
    if (open) {

      const step2 = steps.find(s => s.key === 'step_2');

    }
  }, [open, steps]);
  
  // Use stepStatuses prop if available, otherwise fall back to steps array
  const getStepStatus = (stepKey) => {
    if (stepStatuses && stepStatuses[stepKey]) {
      return stepStatuses[stepKey].status;
    }
    const step = steps.find(s => s.key === stepKey);
    return step ? step.status : 'not_started';
  };

  const isStepDisabled = (stepKey, index) => {
    if (index === 0) return false; // First step is always accessible
    const previousStep = steps[index - 1];
    const previousStepStatus = getStepStatus(previousStep.key);
    return previousStep && previousStepStatus !== 'completed';
  };

  return (
    <Drawer
      variant="temporary"
      anchor="left"
      open={open}
      onClose={onClose}
      ModalProps={{ keepMounted: false }}
      sx={{
        zIndex: 1300,
        [`& .MuiDrawer-paper`]: {
          width: 280,
          boxSizing: 'border-box',
          top: 64, // below AppBar
          height: 'calc(100% - 64px)',
        },
      }}
    >
      <List>
        {steps.map((step, idx) => {
          const label = step.label;
          const status = step.status; // Use step.status directly, not getStepStatus
          const disabled = isStepDisabled(step.key, idx);

          return (
            <ListItem key={step.key} disablePadding>
              <ListItemButton
                selected={currentStep === step.key}
                disabled={disabled}
                onClick={() => {
                  onStepChange(step.key);
                  onClose();
                }}
              >
                <ListItemIcon>{statusIcons[status]}</ListItemIcon>
                <ListItemText primary={label} />
                <Chip
                  label={statusLabels[status]}
                  size="small"
                  sx={{ ml: 1 }}
                  color={status === 'completed' ? 'success' : status === 'in_progress' ? 'warning' : 'default'}
                />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </Drawer>
  );
};

// Export a hamburger icon button for use in header or main page
export function SidebarHamburger({ onClick }) {
  return (
    <IconButton color="inherit" edge="start" onClick={onClick} sx={{ mr: 2 }}>
      <MenuIcon />
    </IconButton>
  );
}

export default StepSidebar; 